import { render, staticRenderFns } from "./QuartzManage.vue?vue&type=template&id=513f773d&scoped=true"
import script from "./QuartzManage.vue?vue&type=script&lang=js"
export * from "./QuartzManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513f773d",
  null
  
)

export default component.exports